import SectionBlock from '@/components/ui/section-block';
import CallToAction from '@/components/cta/call-to-action';
import GroupProducts from '@/components/products/group-products';
import PopularProductsGrid from '@/components/products/popular-products';
import TopAuthorsGrid from '@/components/author/top-authors-grid';
import TopManufacturersGrid from '@/components/manufacturer/top-manufacturers-grid';
import type { HomePageProps } from '@/types';
import ProductGridHome from '@/components/products/grids/home';
import BestSellingProductsGrid from '@/components/products/best-selling-products';
import HomeSearchProvider from '@/lib/services/typesense/search-providers/home';
import { DynamicSections } from '../dynamic-sections/dynamic-sections';
import { buildHomeListContext } from '@/lib/gtm';

export default function CompactLayout({ variables }: Readonly<HomePageProps>) {
  const currentPageGroupId = variables?.group_id ?? null;

  return (
    <div className="flex flex-col flex-1">
      <main className="block w-full xl:overflow-hidden">
        {/* Commenting banner on this type of page */}
        {/* <SectionBlock>
          <Banner layout="compact" variables={variables.types} />
        </SectionBlock> */}

        <DynamicSections variables={variables} />

        {!!variables?.layoutSettings?.bestSelling?.enable && (
          <BestSellingProductsGrid
            variables={variables?.bestSellingProducts}
            title={variables?.layoutSettings?.bestSelling?.title}
          />
        )}

        {!!variables?.layoutSettings?.popularProducts?.enable && (
          <PopularProductsGrid
            variables={variables.popularProducts}
            title={variables?.layoutSettings?.popularProducts?.title}
          />
        )}

        {!!variables?.layoutSettings?.handpickedProducts?.enable && (
          <GroupProducts
            products={variables?.layoutSettings?.handpickedProducts?.products}
            title={variables?.layoutSettings?.handpickedProducts?.title}
            isSlider={
              variables?.layoutSettings?.handpickedProducts?.enableSlider
            }
          />
        )}

        {!!variables?.layoutSettings?.newArrival?.enable && (
          <HomeSearchProvider
            group_id={currentPageGroupId}
            categoryIds={variables?.typeCategoryIds}
          >
            <SectionBlock title={variables?.layoutSettings?.newArrival?.title}>
              <ProductGridHome
                column="five"
                variables={{
                  ...variables.products,
                  sortedBy: 'DESC',
                  orderBy: 'created_at',
                }}
                listContext={buildHomeListContext({
                  type: 'new-arrival',
                  title: variables?.layoutSettings?.newArrival?.title,
                  order: 203,
                })}
              />
            </SectionBlock>
          </HomeSearchProvider>
        )}

        {!!variables?.layoutSettings?.authors?.enable && (
          <TopAuthorsGrid title={variables?.layoutSettings?.authors?.title} />
        )}

        {!!variables?.layoutSettings?.manufactures?.enable && (
          <TopManufacturersGrid
            title={variables?.layoutSettings?.manufactures?.title}
          />
        )}

        {!!variables?.layoutSettings?.callToAction?.enable && <CallToAction />}
      </main>
    </div>
  );
}
